import React from 'react'
import Layout from '../Layout/Layout'
import vector from "../images/ToI.jpg"
import './pilars_of_impact.css'


const Pillars_of_impact = () => {
  return (
        <Layout>

               <div className='uk-container'>
            <div className=' uk-margin-xlarge-top '>

           
            <h1 className='light'>The Precision of Our Mandate: </h1>
            <h4 className='light invest'>Investing in Systems, Not Just Ventures.</h4>

            <h3 className='uk-text-bold light'>The Four Core Pillars</h3>
            <p className='light'>We execute our mission through an integrated,
                 top-down and bottom-up approach, structured across four interconnected pillars: </p>


               <div className='uk-grid uk-margin-large-top'>
                      <div className='uk-width-1-2@s'>
                          <h4 className='uk-text-bold light'>Innovation Development</h4>
                          <p className='light'>We provide structured incubation, acceleration,
                             market access, and cross-border innovation exchange. Our focus
                              is on building resilient, data-driven, gender-inclusive, and 
                              AI-enabled enterprises. </p>
                      </div>

                      <div className='uk-width-1-2@s'>
                            <h4 className='uk-text-bold light'>Research Commercialization</h4>
                          <p className='light'>We bridge the critical gap between academic
                             research outputs and market-ready solutions. This is achieved
                              through several, specialized training, and advisory work for
                               universities and institutions. Our recent work is the nationally 
                               adopted research to commercialization toolkit funded by UKAID
                                (RISA Fund), validated by  major stakeholders as the first
                                 national toolkit fully capturing the research to commercialization 
                                 pathway with the Nigerian context. </p>
                      </div>
               </div>


                  <div className='uk-grid uk-margin-medium-top'>
                      <div className='uk-width-1-2@s'>
                          <h4 className='uk-text-bold light'>Policy, Governance & Advisory</h4>
                          <p className='light'>We shape national and regional innovation systems 
                            by contributing to evidence-based policy development, including 
                            critical work in AI governance. We serve as a strategic advisor 
                            to government and multilateral bodies </p>
                      </div>

                      <div className='uk-width-1-2@s'>
                            <h4 className='uk-text-bold light'>Ecosystem Strengthening</h4>
                          <p className='light'>We build the technical and institutional capacity of 
                            entrepreneurial hubs (ESOs), government agencies, and development 
                            partners to ensure the innovation ecosystem is sustainable.  </p>
                      </div>
               </div>


               <div className='uk-grid'>
                   <div className='uk-width-1-1 uk-text-center'>
                      <img src={vector}  className='voi'/>

                      <div className='uk-margin-large-top'>
                        <h4 className='light'>Theory of Impact</h4>
                        <p className='light focus'>Our work focuses on strengthening the systemic foundations around 
                            innovators—the capacity, policy frameworks, research pipelines, 
                            and market linkages that make innovation growth possible.</p>

                            <p className='light focus'>
                                We track change across three layers:
 Enterprise-Level Outcomes, Institutional Capacity & Policy Influence, and Systems-Level Change

                            </p>
                      </div>
                   </div>
               </div>




            </div>
            </div>




            </Layout>
  )
}

export default Pillars_of_impact